module.exports = __webpack_public_path__ + "img/logo.215bd1b3.png";